export const startPolling = (task, interval, onError = () => null) => {
    let active = true;
    let inFlight = false;
    let errorReported = false;

    const run = async () => {
        if (!active || inFlight) {
            return;
        }
        inFlight = true;
        try {
            await task();
            errorReported = false;
        } catch (error) {
            if (!errorReported) {
                errorReported = true;
                onError(error);
            }
        } finally {
            inFlight = false;
        }
    };

    const timer = setInterval(run, interval);
    return () => {
        active = false;
        clearInterval(timer);
    };
};
